module.exports = __webpack_public_path__ + "img/house_ev_idle_online.e462b089.png";